module.exports = __webpack_public_path__ + "static/media/icon3.9954d805.svg";